import {
  createColumnConfig,
  StandardTableConfigWithNoGroups,
} from "@stenajs-webui/grid";
import { PriceListRow } from "../types/PriceListRow";
import { formatUnaccompanied } from "./priceListValues";

export type PriceListExcelColumnKey = Exclude<keyof PriceListRow, "__typename">;

export const createPriceListExcelConfig = (
  resolveVehicleTypeName: (code: string) => string
): StandardTableConfigWithNoGroups<PriceListRow, PriceListExcelColumnKey> => ({
  keyResolver: (row) =>
    [
      row.routeAgreementNumber,
      row.route,
      row.vehicleType,
      row.length,
      row.weightFrom,
    ].join("-"),
  columnOrder: [
    "routeAgreementNumber",
    "customerIndex",
    "validFrom",
    "validTo",
    "route",
    "sailingCategory",
    "routeAgreementName",
    "vehicleType",
    "length",
    "weightFrom",
    "weightTo",
    "unaccompanied",
    "routeAgreementCurrency",
    "price",
    "customerNumber",
    "movementType",
    "routeAgreementVehicleType",
  ],
  columns: {
    routeAgreementNumber: createColumnConfig(
      (row) => row.routeAgreementNumber,
      { columnLabel: "Agreement" }
    ),
    customerIndex: createColumnConfig((row) => row.customerIndex, {
      columnLabel: "Customer",
    }),
    validFrom: createColumnConfig((row) => row.validFrom, {
      columnLabel: "Valid from",
    }),
    validTo: createColumnConfig((row) => row.validTo, {
      columnLabel: "Valid to",
    }),
    route: createColumnConfig((row) => row.route, { columnLabel: "Route" }),
    sailingCategory: createColumnConfig((row) => row.sailingCategory, {
      columnLabel: "Sailing cat.",
    }),
    routeAgreementName: createColumnConfig((row) => row.routeAgreementName, {
      columnLabel: "Route agreement",
    }),
    vehicleType: createColumnConfig(
      (row) => resolveVehicleTypeName(row.vehicleType),
      { columnLabel: "Vehicle type" }
    ),
    length: createColumnConfig((row) => row.length, {
      columnLabel: "Length (m)",
    }),
    routeAgreementCurrency: createColumnConfig(
      (row) => row.routeAgreementCurrency,
      { columnLabel: "Currency" }
    ),
    price: createColumnConfig((row) => row.price, { columnLabel: "Price" }),
    weightFrom: createColumnConfig((row) => row.weightFrom, {
      columnLabel: "Weight from",
    }),
    weightTo: createColumnConfig((row) => row.weightTo, {
      columnLabel: "Weight to",
    }),
    unaccompanied: createColumnConfig(
      (row) => formatUnaccompanied(row.unaccompanied),
      { columnLabel: "Unacc" }
    ),
    customerNumber: createColumnConfig((row) => row.customerNumber, {
      columnLabel: "Customer no.",
    }),
    movementType: createColumnConfig((row) => row.movementType, {
      columnLabel: "Movement type",
    }),
    routeAgreementVehicleType: createColumnConfig(
      (row) =>
        row.routeAgreementVehicleType
          ? resolveVehicleTypeName(row.routeAgreementVehicleType)
          : row.routeAgreementVehicleType,
      { columnLabel: "Agreement vehicle type" }
    ),
  },
});
